import XXH from 'xxhashjs';

// for non cryptographic/non secure uses only

export function hash64(data: string | ArrayBuffer) {
  return XXH.h64(data, 0x3af530c9b2).toString(16);
}